// Shared types for Value Map Coach Frontend

// Simple mode: 3 fields
export interface SimpleValueMap {
  businessDriver: string;
  painPoint: string;
  measurableOutcome: string;
}

// Advanced mode: 13 fields for Google Sheets integration
export interface AdvancedValueMap {
  customerName: string;
  businessPriorities: [string, string, string]; // Max 30 words each
  digitalPriorities: [string, string, string]; // Max 30 words each
  externalChallenges: [string, string, string]; // Max 30 words each
  internalChallenges: [string, string, string]; // Max 30 words each
}

// Union type for both modes
export type ValueMap = SimpleValueMap | AdvancedValueMap;

// Type guards
export function isAdvancedValueMap(valueMap: ValueMap): valueMap is AdvancedValueMap {
  return 'customerName' in valueMap;
}

export function isSimpleValueMap(valueMap: ValueMap): valueMap is SimpleValueMap {
  return 'businessDriver' in valueMap;
}

export interface Session {
  id: string;
  userEmail: string;
  executiveSummary: string;
  status: 'draft' | 'completed';
  createdAt: string;
  updatedAt: string;
  valueMap?: ValueMap;
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

export interface APIResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
}
